// Navegación nueva de la Academia: pestaña Inicio, selector de curso y, para los alumnos,
// sin la barra negra lateral (en el celular, pestañas abajo).
// 'admins' = solo la ven los administradores, para probarla. 'all' = todos los usuarios.
export const NEW_NAVIGATION_ROLLOUT: 'admins' | 'all' = 'all';

// Un administrador puede ver la Academia como alumno (sin la barra negra) para revisar el diseño.
export const STUDENT_VIEW_PREVIEW_KEY = 'studentViewPreview';

// Calendario: clases en vivo de los últimos 14 días en la agenda con "Ver grabación" (y ▶ en el mensual).
// 'admins' = solo administradores, para revisarlo. 'all' = todos los alumnos.
export const CALENDAR_RECORDINGS_ROLLOUT: 'admins' | 'all' = 'all';
